export const Directon= {
    up: "up",
    down: "down",
    top: "top",
    bottom: "bottom",
    both: "both",
};
